import { Component } from '@angular/core';
import * as moment from "moment";
import { Http } from '@angular/http';
import {Params} from "../../params";
import { GlobalProvider } from "../../../providers/global/global";
import {LoadingController, ModalController, AlertController} from "ionic-angular";
import * as firebase from 'firebase/app';
import {FindCustomerComponent} from "../../../components/find-customer/find-customer";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import {CsvService} from "angular2-json2csv";

/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-payments',
  templateUrl: 'payments.html',
})
export class PaymentsPage {
  orders = [];
  items = [];
  month;
  year;
  years = [];
  money = Params.money;
  customerTypes = {
    1: "Cliente Nuevo",
    2: "Cliente Activo",
    3: "Ex Cliente"
  }
  constructor(
    public http: Http,
    private modalCtrl : ModalController,
    private loadingCtrl: LoadingController,
    public global: GlobalProvider,
    private _csvService: CsvService,
    public alertCtrl: AlertController) {


    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;


  }

  transfers(){
      /* let modal = this.modalCtrl.create(TransfersPage);
      modal.present();
      modal.onDidDismiss((customer) => {

      }) */
  }

  invoice(c){
    window.open(c.boleta.urlView, '_blank');
  }

  export(){
    let texts = [];
    for (let i = 0; i < this.orders.length; i++) {
      const c = this.orders[i];
      texts.push({
        Fecha: new Date(c.created_at.seconds*1000).toLocaleDateString(),
        Monto: c.amount,
        Descripcion: c.description,
        Tipo: Params.parse_xls(c.payment.payment_type),
        "Nombre Cliente": Params.parse_xls(c.customer ? c.customer.assigned_name : 'n/a'),
        "Email Cliente": c.customer ? c.customer.email : 'n/a',
        Boleta: c.boleta ? c.boleta.id: 's/b',
      })
    }
    this._csvService.download(texts, 'Pagos_'+new Date().toJSON());
  }

  load(){
    console.log('load');
    let loading = this.loadingCtrl.create({
      content : "Espere porfavor"
    })
    loading.present();

    firebase.firestore().collection('payments').doc(this.year + this.month).collection('transactions')
      .orderBy("created_at", "desc")
      .get()
      .then((snap)=>{
        const orders = [];
        snap.forEach((x) => {
          const t = { trans_id : x.id, period: this.year + this.month, ... x.data() };
          t['assign'] = this.global.existsCustomer(t['customer']['email'],false);
          orders.push(t);
        });
        this.orders = orders;
        console.log(orders);
        this.initializeItems();
        loading.dismiss();
      })
  }

  assign(c){
    // preguntar si corresponde al automático
    console.log(c);
    if(c.assign.type == 2 || c.assign.type == 3 ){
      const prompt = this.alertCtrl.create({
        title: '¡Coincide!',
        message: "Hemos encontrado este correo asociado con el nombre de <b>"+c.assign.name+" </b>",
        buttons: [
          {
            text: 'No es',
            handler: data => {
              this.findUserToAssignPay(c);
            }
          },
          {
            text: '¡Si es! asignar pago',
            handler: data => {
              firebase.firestore().collection('payments').doc(c.period).collection('transactions')
                .doc(c.trans_id)
                .set({
                  customer: {
                    assigned: c.assign.customer,
                    assigned_email : c.assign.email,
                    assigned_name : c.assign.name
                  }
                }, { merge : true})
                .then(()=>this.load())
            }
          }
        ]
      });
      prompt.present();
    }else{
      this.findUserToAssignPay(c)
    }
  }

  desassign(c){
    firebase.firestore().collection('payments').doc(c.period).collection('transactions')
      .doc(c.trans_id)
      .set({
        customer: {
          assigned: null,
          assigned_email : null,
          assigned_name : null,
        }
      }, { merge : true})
      .then(()=>this.load())
  }

  findUserToAssignPay(c){
    console.log(c);
    let modal = this.modalCtrl.create(FindCustomerComponent);
    modal.present();
    modal.onDidDismiss((customer) =>{
      if(customer){
        console.log(customer);
        const prompt = this.alertCtrl.create({
          title: 'Asignando pago',
          message: "¿Está seguro/a de asociar el pago a "+customer.name+" "+customer.lastname+"?",
          buttons: [
            {
              text: 'Cancelar',
              handler: data => {
                console.log('Cancel clicked');
              }
            },
            {
              text: '¡Si!',
              handler: data => {
                firebase.firestore().collection('payments').doc(c.period).collection('transactions')
                  .doc(c.trans_id)
                  .set({
                    customer: {
                      assigned: Params.md5(customer.email),
                      assigned_email : customer.email,
                      assigned_name : customer.name+" "+customer.lastname,
                    }
                  }, { merge : true})
                  .then(()=>this.load())
              }
            }
          ]
        });
        prompt.present();
      }

    })
  }

  addPayment(){
    let modal = this.modalCtrl.create(FindCustomerComponent);
    modal.present();
    modal.onDidDismiss((customer) =>{
      const prompt = this.alertCtrl.create({
        title: 'Creando pago para '+customer.name,
        message: "Enter a name for this new album you're so keen on adding",
        inputs: [
          {
            name: 'title',
            placeholder: 'Title'
          },
        ],
        buttons: [
          {
            text: 'Cancel',
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Save',
            handler: data => {
              console.log('Saved clicked');
            }
          }
        ]
      });
      prompt.present();
    })
  }

  statusName(status){
    let st = 'n/a';
    if(status == 'on-hold') st = 'En Espera';
    if(status == 'successful') st = 'Pagado';
    if(status == 'pending') st = 'Pendiente';
    if(status == 'cancelled') st = 'Cancelado';
    if(status == 'failed') st = 'Fallido';
    return st;
  }

  statusColor(status){
    let st = 'n/a';
    if(status == 'on-hold') st = 'light';
    if(status == 'successful') st = 'secondary';
    if(status == 'pending') st = 'dark';
    if(status == 'cancelled') st = 'dark';
    if(status == 'failed') st = 'danger';
    return st;
  }

  fromNow(date){
    return moment(date.seconds * 1000).format('DD-MM-YY HH:mm:ss');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrdersPage');
    this.load();
  }

  initializeItems() {
    this.items = this.orders;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.customer.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.customer.email.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  filter(){

  }
}



// WEBPACK FOOTER //
// ./src/pages/pay/payments/payments.ts